<template>
  <div>
    <el-card v-loading="loading" style="margin-bottom: 20px">
      <div style="overflow: hidden; line-height: 36px">
        审核状态：{{ dist[detail.customsAuditStatus] }}
        <el-button
          type="primary"
          v-if="
            (detail.customsAuditStatus === 'INIT' ||
              detail.customsAuditStatus === 'CUSTOMS_AUDIT_REJECT') &&
            detail.returnStatus !== 'RETURN_CANCEL'
          "
          v-on:click="submitAudit"
          style="float: right; margin: 0 10px"
          >申请退货</el-button
        >
        <el-button
          type="primary"
          v-if="
            (detail.customsAuditStatus === 'INIT' ||
              detail.customsAuditStatus === 'CUSTOMS_AUDITING') &&
            detail.returnStatus !== 'RETURN_CANCEL'
          "
          v-on:click="cancelReturn"
          style="float: right; margin: 0 10px"
          >取消退货</el-button
        >
      </div>
    </el-card>

    <el-card v-loading="loading" class="pro-detail">
      <!-- 基本信息 -->

      <el-row class="info">
        <el-form label-width="80" :inline="true">
          <el-row>
            <el-col :span="24">
              <h3>基本信息</h3>
            </el-col>
            <el-col :span="8">
              <el-form-item label="原订单编号：">
                {{ detail.merchantOrderNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申报企业：">
                {{ detail.declareCompanyName }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货运单号：">
                {{ detail.mailNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货申报编号：">
                {{ detail.customsGoodsReturnOrderNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电商平台：">
                {{ detail.companyName }}
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
                        <el-form-item label="申报关区：">
                            {{detail.portName}}
                        </el-form-item>
                    </el-col> -->
          </el-row>
          <!-- <el-row v-if="detail.cdGoodsReturnOrderConsignee">
            <el-divider></el-divider>
            <el-col :span="24">
              <h3>收件人信息</h3>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收货人：">
                {{ detail.cdGoodsReturnOrderConsignee.consigneeName }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号码：">
                {{ detail.cdGoodsReturnOrderConsignee.consigneeMobile }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号：">
                {{ detail.cdGoodsReturnOrderConsignee.consigneeIdNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地址：">
                {{ detail.cdGoodsReturnOrderConsignee.consigneeAddress }}
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row v-if="detail.cdGoodsReturnOrderPaymentInfo">
            <el-divider></el-divider>
            <el-col :span="24">
              <h3>支付信息</h3>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="支付人姓名：">
                {{ detail.cdGoodsReturnOrderPaymentInfo.payerName }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号：">
                {{ detail.cdGoodsReturnOrderPaymentInfo.payerIdNumber }}
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="支付方式：">
                {{ detail.cdGoodsReturnOrderPaymentInfo.payTypeDesc }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付金额：">
                {{ detail.cdGoodsReturnOrderPaymentInfo.tradeAmount }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付时间：">
                {{ formatDate(detail.cdGoodsReturnOrderPaymentInfo.paidTime) }}
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="流水号：">
                {{ detail.cdGoodsReturnOrderPaymentInfo.payNo }}
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-divider></el-divider>
            <el-col :span="24">
              <h3>仓储信息</h3>
            </el-col>
            <!-- <el-col :span="8">
                        <el-form-item label="发货仓库：">
                        </el-form-item>
                    </el-col> -->
            <el-col :span="8">
              <el-form-item label="原快递公司：">
                {{ detail.logisticsName }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="原运单号：">
                {{ detail.logisticsNo }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-divider></el-divider>

      <!-- 商品信息 -->
      <el-row>
        <el-col :span="24">
          <h3>商品明细</h3>
        </el-col>
      </el-row>

      <el-row class="info">
        <element-table
          headerClassName="stock-table"
          :data="detail.cdGoodsReturnOrderSkuInfos"
          :columns="skuListColumns"
          :loading="loading"
          border
        ></element-table>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { formatDate } from "@/utils/common";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      Id: this.$route.params.id,
      loading: false,
      detail: {},
      skuListColumns: [
        {
          title: "商品SKU",
          key: "skuId",
          minWidth: 150,
          align: "center",
          fixed: "left",
        },
        {
          title: "料号",
          key: "thirdSkuId",
          minWidth: 160,
          align: "center",
        },
        {
          title: "商品条码",
          key: "barcode",
          minWidth: 160,
          align: "center",
        },
        {
          title: "商品名称",
          key: "goodsName",
          minWidth: 160,
          align: "center",
        },
        {
          title: "备案商品名称",
          key: "goodsDeclareName",
          minWidth: 160,
          align: "center",
        },
        {
          title: "hs编码",
          key: "hsCode",
          minWidth: 130,
          align: "center",
        },
        {
          title: "金额",
          key: "unitAmount",
          minWidth: 100,
          align: "center",
        },
        {
          title: "数量",
          key: "quantity",
          minWidth: 100,
          align: "center",
        },
        {
          title: "税金",
          key: "taxAmount",
          minWidth: 100,
          align: "center",
        },
      ],
      dist: {
        INIT: "初始化",
        CUSTOMS_AUDITING: "待总署审核",
        CUSTOMS_AUDIT_PASS: "总署审核通过",
        CUSTOMS_AUDIT_REJECT: "总署驳回",
      },
      declareDetailInfo: {
        eEnterprise: {},
        ePlatformEnterprise: {},
        declareEnterprise: {},
        paymentInfo: {},
        payerInfo: {},
        consigneeInfo: {},
        ccbBizState: undefined,
      },
      region: {
        provinces: [],
        cities: [],
        areas: [],
      },
    };
  },
  components: {
    ElementTable,
  },
  watch: {
    $route(to, from) {
      if (to.name === "goodsReturnDetail") {
        this.Id = this.$route.params.id;
        this.fetch();
      }
    },
  },
  created() {
    this.Id = this.$route.params.id;
    this.fetch();
  },
  mounted() {
    this.Id = this.$route.params.id;
  },
  methods: {
    ...mapActions("danding", [
      "importGoodsReturnExcel",
      "previewGoodsReturnData",
      "queryGoodsReturnList",
      "cancelGoodsReturn",
      "getGoodsReturnDetail",
      "finishGoodsReturn",
      "submitGoodsReturnOrder",
      "exportGoodsReturnOrder",
    ]),
    submitAudit(id) {
      this.$confirm("确定提交退货申请至平台审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((action) => {
          let list = [this.Id];
          this.submitGoodsReturnOrder({
            request: { customsGoodsReturnOrderNos: list },
          }).then((res) => {
            if (res.failureList.length) {
              this.$message.warning(
                `有${res.failureList.length}条数据提交失败`
              );
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancelReturn(id) {
      this.$confirm("是否确定取消退货订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((res) => {
          let list = [this.Id];
          this.cancelGoodsReturn({
            request: { customsGoodsReturnOrderNos: list },
          }).then((res) => {
            if (res.failureList.length) {
              this.$message.warning(
                `有${res.failureList.length}条数据提交失败`
              );
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取入库单详情
    fetch() {
      this.loading = true;
      this.getGoodsReturnDetail({
        customsGoodsReturnOrderNo: this.Id,
      })
        .then((res) => {
          this.detail = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    formatDate,
  },
};
</script>

<style lang="scss">
.pro-detail {
  .info-title {
    height: 64px;
    background: #f5f5f5;
    color: #17181a;
    // font-size: 20px;
    font-weight: bold;
  }

  .info {
    padding: 10px 0 30px;

    .address {
      white-space: nowrap;

      .el-input {
        width: 33% !important;
      }
    }
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-alert__title {
    font-size: 20px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}
</style>
